export default __webpack_public_path__ + "static/media/safari_setting_partial_2.9f523a21.png";